export default __webpack_public_path__ + "c2c57418d059d192a459c481f94478e0.png";